module.exports = __webpack_public_path__ + "img/56.a4616ab5.png";